export default __webpack_public_path__ + "static/media/disabled-right.61a43b76.svg";